const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTuttiColorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 633 614",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2141.79,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    transform: "matrix(4.16667,0,0,4.16667,2141.79,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 151.912,
    height: 147.143,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,56.5562,98.9638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(47,60,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,57.1041,98.5228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(48,60,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,57.6546,98.0818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(49,60,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,58.2078,97.6408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(50,61,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,58.7635,97.1998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(51,61,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,59.3217,96.7589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(52,61,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,59.8823,96.3179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(53,62,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,60.4453,95.8769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(54,62,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,61.0106,95.4359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(55,62,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,61.5782,94.9949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(56,63,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,62.148,94.5539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(56,63,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,62.72,94.113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(57,63,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,63.2941,93.672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(58,63,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,63.8703,93.231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(59,63,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,64.4485,92.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(60,64,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,65.0286,92.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(61,64,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,65.6106,91.908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(62,64,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,66.1944,91.467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(63,65,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,66.78,91.0261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(63,65,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,67.3674,90.5851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(64,65,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,67.9564,90.1441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(65,66,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,68.547,89.7031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(66,66,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,69.1392,89.2621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(67,66,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,69.733,88.8211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(68,66,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,70.3281,88.3802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(69,66,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,70.9247,87.9392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(70,67,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,71.5226,87.4982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(70,67,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,72.1219,87.0572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(71,67,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,72.7223,86.6162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(72,67,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,73.3239,86.1752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(73,68,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,73.9267,85.7343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(74,68,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,74.5305,85.2933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(74,68,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,75.1354,84.8523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(75,68,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,75.7412,84.4113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(76,69,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,76.3479,83.9703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(77,69,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,76.9555,83.5293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(78,69,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,77.5639,83.0883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(79,69,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,78.173,82.6474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(80,70,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,78.7828,82.2064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(81,70,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,79.3932,81.7654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(81,70,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,80.0043,81.3244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(82,71,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,80.6158,80.8834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(83,71,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,81.2279,80.4424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(84,71,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,81.8403,80.0015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(85,71,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,82.4531,79.5605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(85,71,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,83.0662,79.1195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(86,72,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,83.6796,78.6785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(87,72,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,84.2932,78.2375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(88,72,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,84.9069,77.7965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(89,73,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,85.5207,77.3556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(90,73,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,86.1346,76.9146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(91,73,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,86.7484,76.4736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(92,74,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,87.3621,76.0326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(92,74,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,87.9758,75.5916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(93,74,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,88.5892,75.1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(94,74,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,89.2024,74.7096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(95,74,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,89.8153,74.2687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(96,75,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,90.4279,73.8277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(96,75,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,91.04,73.3867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(98,75,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,91.6517,72.9457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(99,76,67)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,92.2629,72.5047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(99,76,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,92.8735,72.0637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(100,76,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,93.4835,71.6227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(101,76,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,94.0929,71.1818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(102,77,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,94.7015,70.7408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(103,77,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,95.3093,70.2998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(103,77,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,95.9163,69.8588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(104,77,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,96.5224,69.4178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(105,77,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,97.1275,68.9768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(106,78,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,97.7316,68.5358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(107,78,66)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,98.3347,68.0949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(108,78,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,98.9367,67.6539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(109,79,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,99.5375,67.2129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(109,79,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,100.137,66.7719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(110,79,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,100.735,66.3309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(112,79,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,101.332,65.8899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(112,80,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,101.928,65.449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(113,80,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,102.522,65.008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(114,80,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,103.115,64.567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(115,81,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,103.706,64.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(116,81,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,104.295,63.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(117,81,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,104.883,63.244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(118,82,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,105.469,62.8031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(119,82,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,106.054,62.3621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(119,82,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,106.636,61.9211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(120,82,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,107.217,61.4801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(121,82,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,107.796,61.0391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(122,82,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,108.372,60.5981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(123,83,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,108.947,60.1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(124,83,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,109.52,59.7162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(125,83,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,110.09,59.2752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(126,84,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,110.658,58.8342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(127,84,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,111.224,58.3932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(128,84,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,111.788,57.9522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(128,84,63)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,112.349,57.5112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(130,84,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,112.908,57.0703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(131,85,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,113.465,56.6293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(131,85,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,114.019,56.1883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(132,85,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,114.57,55.7473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(134,86,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,115.119,55.3063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(134,86,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,114.857,54.8685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(135,86,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,114.263,54.4321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(136,86,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,113.668,53.9956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(137,87,62)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,113.073,53.5592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(138,87,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,112.478,53.1227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(139,87,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,111.883,52.6862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(140,87,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,111.288,52.2498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(141,87,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,110.693,51.8133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(142,88,61)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,110.098,51.3769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(143,88,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,109.503,50.9404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(144,88,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,108.908,50.5039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(145,89,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,108.314,50.0675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(145,89,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,107.719,49.631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(147,89,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,107.124,49.1946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(148,90,60)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,106.529,48.7581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(148,90,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,105.934,48.3216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(150,90,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,105.339,47.8852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(151,90,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,104.744,47.4487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(151,90,59)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,104.149,47.0123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(153,91,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,103.554,46.5758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(153,91,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,102.959,46.1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(154,91,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,102.364,45.7029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(156,92,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,101.77,45.2664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(156,92,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,101.174,44.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(157,92,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,100.58,44.3935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(159,93,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,99.9847,43.9571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(159,92,57)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,99.3898,43.5206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(161,93,57)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,98.7949,43.0841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(161,93,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,98.2,42.6477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(162,93,57)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,97.6051,42.2112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(164,94,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,97.0102,41.7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(164,94,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,96.4153,41.3383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(165,94,56)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,95.8204,40.9018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(166,94,55)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,95.2254,40.4654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(167,95,55)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,94.6305,40.0289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(169,95,55)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,94.0356,39.5925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(169,95,55)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,93.4407,39.156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(171,95,54)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,92.8458,38.7195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(172,96,54)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,92.2509,38.2831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(172,96,54)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,91.656,37.8466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(174,96,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,91.0611,37.4102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(174,96,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,90.4662,36.9737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(176,96,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,89.8712,36.5373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(177,97,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,89.2763,36.1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(178,97,52)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,88.6814,35.6643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(179,97,53)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,88.0865,35.2279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(179,97,52)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,87.4916,34.7914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(181,98,52)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,86.8967,34.355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(182,98,52)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,86.3018,33.9185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(183,98,51)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,85.7069,33.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(184,98,51)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,85.1119,33.0456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(185,98,50)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,84.517,32.6091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(186,99,51)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,83.9221,32.1727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(187,99,50)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,83.3272,31.7362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(188,99,50)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,82.7323,31.2997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(189,100,50)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,82.1374,30.8633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(190,100,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,81.5425,30.4268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(191,100,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,80.9476,29.9904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(192,100,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,80.3527,29.5539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(194,101,49)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,79.7578,29.1175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(194,101,48)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,79.1629,28.681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(196,101,48)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,78.5679,28.2445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(196,101,48)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,77.973,27.8081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(198,102,47)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,77.3781,27.3716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(199,102,47)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,76.7832,26.9352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(200,102,47)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,76.1883,26.4987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(201,103,47)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,75.5934,26.0622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(202,103,46)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,74.9985,25.6258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(203,103,46)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,74.4036,25.1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(204,103,46)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,73.8087,24.7529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(205,103,45)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,73.2137,24.3164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(206,104,45)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,72.6188,23.8799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(207,104,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,72.0239,23.4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(208,104,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,71.429,23.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(210,105,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,70.8341,22.5706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(211,105,44)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,70.2392,22.1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(212,105,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,69.6443,21.6977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(213,105,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,69.0494,21.2612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(214,106,43)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,68.4544,20.8247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(216,106,42)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,67.8595,20.3883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(217,106,42)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,67.2646,19.9518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(218,106,41)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,66.6697,19.5154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(220,107,41)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,66.0748,19.0789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(220,107,41)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,65.4799,18.6424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(222,107,40)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,64.885,18.206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(223,107,40)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,64.2901,17.7695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(225,108,39)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,63.6952,17.3331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(226,108,39)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,63.1003,16.8966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(227,109,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,62.5054,16.4601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(229,109,38)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,61.9104,16.0237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(230,108,37)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,61.3155,15.5872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(232,109,37)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,60.7206,15.1508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(233,109,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,60.1257,14.7143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(234,110,36)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,59.5308,14.2779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(236,110,35)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,58.9359,13.8414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(237,110,35)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,58.341,13.4049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(239,111,34)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,57.7461,12.9685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(240,111,34)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,57.1511,12.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(241,110,33)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,56.5562,12.0956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-19.661,-19.661C-30.52,-19.661 -39.322,-10.858 -39.322,0C-39.322,10.859 -30.52,19.661 -19.661,19.661C-8.802,19.661 0,10.859 0,0C0,-10.858 -8.802,-19.661 -19.661,-19.661",
    style: {
      fill: "rgb(243,111,33)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuttiColorLogo);
export default __webpack_public_path__ + "static/media/Tutti_color_logo.16a8a0db604f6a1d03cb4ef5ac56f8b9.svg";
export { ForwardRef as ReactComponent };